module.exports = __webpack_public_path__ + "static/media/yearly-banner.7b5ca287.png";